import type { AnchorHTMLAttributes } from 'react';

import type { ValidSitecoreLink } from 'components/SitecoreLink';

import ImagesGrid from './ImagesGrid';
import ShortcutImage from './ShortcutImage';
import type { ItemSize } from './types';

interface BaseItemProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
	imgSrc: string;
	key?: string;
}

interface RegularLinkItemProps extends BaseItemProps {
	href: string;
	link?: never;
	text: string;
}

interface SitecoreLinkItemProps extends BaseItemProps {
	href?: never;
	link: ValidSitecoreLink;
	text?: never;
}

type ItemProps = RegularLinkItemProps | SitecoreLinkItemProps;

interface Props {
	className?: string;
	items: ItemProps[];
	size?: ItemSize;
}

/** Linked images with an arrow icon and text below. */
export default function BlockShortcutImages({
	className,
	items,
	size = 'regular',
}: Props) {
	return (
		<ImagesGrid as="ul" size={size} className={className}>
			{items.map((item) => (
				<li
					key={item.key || item.href || item.link?.href}
					className="col-span-1"
				>
					<ShortcutImage
						{...item}
						imgWidth={size === 'large' ? 393 : 254}
						imgHeight={size === 'large' ? 197 : 127}
						hideIconWhenSmall={size === 'regular'}
						className="w-full"
					/>
				</li>
			))}
		</ImagesGrid>
	);
}
BlockShortcutImages.displayName = 'BlockShortcutImages';
